<!--
 * @Description: 名单库添加
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <div>
    <table-render
      ref="nameListTableRender"
      :config="config"
      :propData="propData"
      :rowClassName="
        ({ row, rowIndex }) =>
          getUnqualifiedRowConfig({
            row: row,
            rowIndex: rowIndex,
            isNotUnqualified: isNotUnqualified(row)
          })
      "
      rowKey="userId"
      height="55vh"
    />
    <div class="footer">
      <span class="select-all" @click="chooseAll">全选</span>
      <div class="footer-button-group">
        <el-button type="primary" @click="confirm" :loading="btLoading">
          确认添加
        </el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import tableRender from '@/components/tableRender';
import config from './config';
import { projectPersonnelManagement } from '@/api/ajax';
import { btLoading } from '@/Mixin/btLoading';
import { deepClone } from '@/tools';
import { getUnqualifiedRowConfig } from '@/methods/unqualified';
export default {
  mixins: [btLoading],
  name: 'NameList',
  inject: ['_parent'], // src\page\project-personnel-inside\list\index.vue
  data() {
    return {
      getUnqualifiedRowConfig,
      config: [],
      propData: {
        query: {
          projectId: this.$route.query.id,
          taskDt: this.$route.query.taskDt
        }
      },
      selection: [],
      personLabels: {} // 解决切换页面后，表格中输入的 本次导入标签 被重置问题
    };
  },
  components: { tableRender },
  computed: {
    // 0为人 1为个体
    type() {
      return this.$store.state.homeProject.projectStructureType === 2 ? 1 : 0;
    }
  },
  watch: {},
  methods: {
    isNotUnqualified(row) {
      return !(
        ('superviseStatus' in row && row.superviseStatus === 3) ||
        row.zbBlackStatus === 2
      );
    },
    async chooseAll() {
      await this.$refs.nameListTableRender.selectAllByRowKey({
        listAjax: projectPersonnelManagement.panelLibraryAddsAListCheckAll
      });
    },
    cancel() {
      this.$xrkDialog.remove();
    },
    selectedDataHandler(selection) {
      let userInfoList = [];
      selection.map(params => {
        userInfoList.push({
          userId: params.userId,
          userTag: this.personLabels[params.userId]
        });
      });
      let data = {
        projectId: this.$route.query.id,
        taskDt: this.$route.query.taskDt,
        userInfoList,
        btnLoading: true
      };
      return data;
    },
    emptyCheck() {
      if (!this.selection.length) {
        this.$message.error('请至少选择一个人员');
        return false;
      }
      return true;
    },
    confirm() {
      if (!this.emptyCheck()) {
        return;
      }
      this.SET_BTLOADING(true);
      // 该接口单独处理的传参方式
      projectPersonnelManagement
        .savePanelLibraryAddsAList(this.selectedDataHandler(this.selection))
        .then(() => {
          // 刷新当前列表
          this.$refs.nameListTableRender.saveSuccess();
          this.$refs.nameListTableRender.clearTableSelection();
          this.SET_BTLOADING(false);
          this.$xrkDialog.remove();
          // 刷新最外层列表
          this._parent.$children[0].saveSuccess();
        });
    }
  },
  created() {
    const part = deepClone(config[this.type]);
    const removeFields = [];
    const removeSearchs = [];
    if (!this.$checkNeedUserTag(this.$store.state.homeProject)) {
      // 特定情况需要删除人员标签
      removeFields.push(...['其他项目标签', '本次导入标签']);
      removeSearchs.push(...['其他项目标签']);
    }
    const dealConfig = (arr, rmArr) => {
      rmArr.length > 0 &&
        rmArr.forEach(rmLabel => {
          arr.forEach((obj, index) => {
            if (rmLabel === obj.label) {
              arr.splice(index, 1);
            }
          });
        });
    };
    dealConfig(part[0].childMenu[0].fields, removeFields);
    dealConfig(part[0].childMenu[0].search, removeSearchs);
    this.config = part;

    this.$nextTick(() => {
      this.selection = this.$refs.nameListTableRender.$refs.table.selection;
    });
  }
};
</script>

<style scoped lang="scss">
.select-all {
  cursor: pointer;
}
.footer {
  padding: 0 25px;
}
.footer-button-group {
  display: flex;
  justify-content: flex-end;
}
</style>
